
import { PublicClientApplication } from '@azure/msal-browser';

    const currentOrigin = window.location.origin
      const msalConfig = {
        auth: {
          clientId: process.env.VUE_APP_CLIENT_ID,
          authority: process.env.VUE_APP_AUTHORITY,
          redirectUri: currentOrigin,
          navigateToLoginRequestUrl: false,
        },
        cache: {
          cacheLocation: 'sessionStorage',
          storeAuthStateInCookie: false,
        },
        system: {
          navigateToLoginRequestUrl: false,
        },
      }

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
